
import { api } from "../../../utils/api";

export const deleteFile = async (fileIds, type = "drive_enterprise") => {
  try {
    const data = {
      type: `${type}`,
      files_ids: Array.isArray(fileIds) ? fileIds : [fileIds]
    };
    
    const response = await api.post(`/drive-delete`, data);
    return response.data;
  } catch (error) {
    throw new Error("Error deleting file");
  }
};
